export interface TabProps {
  id: string
  name: string
  isActive: boolean
  handleClick: (id: string) => void
}

export const useTab = (props: TabProps) => {
  return {
    ...props,
  }
}
